import type { HotelsLocale } from './en'

export const hotelsNe = {
  nav: {
    dashboard: 'ड्यासबोर्ड',
    settings: 'सेटिङहरू',
    wakeupScheduling: 'वेक-अप तालिका',
    wakeupHistory: 'वेक-अप इतिहास',
  },
  common: {
    unknown: 'अज्ञात',
    notAvailable: 'N/A',
    placeholder: '—',
    search: 'खोज',
    entries: 'रेकर्ड',
    show: 'देखाउनुहोस्',
    retry: 'फेरि प्रयास गर्नुहोस्',
    loading: 'लोड हुँदैछ',
    previous: 'अघिल्लो',
    next: 'अर्को',
    dayPlaceholder: 'दिन...',
    timePlaceholder: 'समय...',
    filterTimesPlaceholder: 'समय फिल्टर गर्नुहोस्...',
  },
  dialogs: {
    confirm: 'पुष्टि',
    cancel: 'रद्द गर्नुहोस्',
  },
  errors: {
    loadRooms: 'कोठाहरू लोड गर्न असफल',
    loadWakeupHistory: 'वेक-अप इतिहास लोड गर्न असफल',
    loadPbxSettings: 'पीबीएक्स सेटिङहरू लोड गर्न असफल',
    loadExtensions: 'एक्सटेन्सनहरू लोड गर्न असफल',
  },
  pagination: {
    previousPage: 'अघिल्लो पृष्ठ',
    nextPage: 'अर्को पृष्ठ',
    resultsPerPage: 'प्रति पृष्ठ परिणाम:',
    all: 'सबै',
    jumpToPage: 'पृष्ठ {{page}} मा जानुहोस्',
    recordRange: '{{start}}—{{end}} मध्ये {{total}}',
    recordRangeEmpty: '0 मध्ये 0',
  },
  tableToolbar: {
    entriesOnly: '{{count}} रेकर्ड',
    entriesFiltered: '{{total}} मध्ये {{filtered}} रेकर्ड',
    resultsPerPage: 'प्रति पृष्ठ परिणाम:',
    showingSummary: '{{count}} मध्ये {{start}}-{{end}} देखाउँदै',
  },
  datePresets: {
    today: 'आज',
    tomorrow: 'भोलि',
    yesterday: 'हिजो',
    '1week': '१ हप्ता',
    '2weeks': '२ हप्ता',
    '3weeks': '३ हप्ता',
    '4weeks': '४ हप्ता',
    all: 'सबै',
  },
  wakeupStatus: {
    scheduled: 'तालिकाबद्ध',
    tried: 'प्रयास गरियो',
    cleared: 'हटाइयो',
    canceled: 'रद्द गरियो',
  },
  dashboard: {
    incomingCallHistory: 'आगमन कल इतिहास',
    emergencyHistory: '911 इतिहास (7 दिन)',
    roomStatus: 'कोठा स्थिति',
    searchCalls: 'कल खोज्नुहोस्...',
    noIncomingCalls: 'कुनै आगमन कल छैन',
    noMatchingCalls: 'तपाईंको खोजसँग मिल्ने कल भेटिएन',
    number: 'नम्बर',
    name: 'नाम',
    time: 'समय',
    destination: 'गन्तव्य',
    room: 'कोठा',
    timeAndDate: 'समय र मिति',
    duration: 'अवधि',
    noEmergencyCalls: 'कुनै कल छैन',
    emergencyFooter: '* {{destination}} मा कल गरिएको',
    refreshingIn: '{{seconds}} सेकेन्डमा रिफ्रेस हुँदैछ',
    noRoomsTitle: 'कोठा फेला परेन',
    noRoomsDescription: 'यस पीबीएक्सका लागि कुनै होटल कोठा सेट गरिएको छैन।',
    resetRoomsSuccess: '{{count}} कोठा Dirty मा रिसेट गरियो',
    resetRoomsFailed: 'कोठा रिसेट गर्न असफल',
    roomStatusActions: {
      dirty: 'Dirty',
      clean: 'Clean',
      occupied: 'Occupied',
      inspected: 'Inspected',
    },
    roomTile: {
      openAria: 'कोठा {{room}} खोल्नुहोस्',
    },
    roomDetail: {
      title: 'कोठा {{room}}',
      changeStatus: 'स्थिति परिवर्तन गर्नुहोस्',
      cleanOrInspectedWarning:
        'Clean वा Inspected मा सेट गर्दा सक्रिय वेक-अप कल रद्द हुन्छ र भ्वाइसमेल मेटिन्छ।',
      activeWakeups: 'सक्रिय वेक-अपहरू',
      voicemails: 'भ्वाइसमेलहरू',
      statusUpdated: 'कोठाको स्थिति अद्यावधिक भयो',
      statusUpdateFailed: 'कोठाको स्थिति अद्यावधिक गर्न असफल',
    },
    resetAllRooms: {
      button: 'सबै कोठा Dirty मा रिसेट गर्नुहोस्',
      title: 'सबै कोठा रिसेट गर्नुहोस्',
      description:
        'यसले सबै कोठालाई Dirty स्थितिमा राख्छ। वेक-अप कल र भ्वाइसमेल प्रभावित हुँदैनन्। के तपाईं निश्चित हुनुहुन्छ?',
      confirm: 'सबै रिसेट गर्नुहोस्',
    },
    wakeupPopover: {
      title: 'वेक-अप कलहरू',
      manageAria: 'वेक-अप कलहरू व्यवस्थापन गर्नुहोस्',
      manageAriaPending: 'वेक-अप कलहरू व्यवस्थापन गर्नुहोस् (बाँकी)',
      manageAriaCleared: 'वेक-अप कलहरू व्यवस्थापन गर्नुहोस् (हटाइयो)',
      clearAll: 'सबै हटाउने?',
      clearAllSuccess: '{{count}} वेक-अप{{suffix}} रद्द गरियो',
      clearAllFailed: 'वेक-अपहरू हटाउन असफल',
      scheduleSuccess: 'वेक-अप कल तालिकाबद्ध गरियो',
      scheduleFailed: 'वेक-अप तालिका गर्न असफल',
      addAria: 'वेक-अप कल थप्नुहोस्',
      loading: 'लोड हुँदैछ...',
      none: 'कुनै सक्रिय वेक-अप कल छैन',
      schedule: 'तालिका',
      cancelAria: 'वेक-अप रद्द गर्नुहोस्',
      cancelAriaWithTime: '{{time}} को वेक-अप रद्द गर्नुहोस्',
    },
    voicemailPopover: {
      title: 'भ्वाइसमेलहरू',
      manageAria: 'भ्वाइसमेल व्यवस्थापन गर्नुहोस्',
      manageAriaWithCount_one:
        'भ्वाइसमेल व्यवस्थापन गर्नुहोस् ({{count}} भ्वाइसमेल)',
      manageAriaWithCount_other:
        'भ्वाइसमेल व्यवस्थापन गर्नुहोस् ({{count}} भ्वाइसमेल)',
      clearAll: 'सबै हटाउने?',
      clearAllSuccess_one: '{{count}} भ्वाइसमेल हटाइयो',
      clearAllSuccess_other: '{{count}} भ्वाइसमेल हटाइयो',
      clearAllFailed: 'भ्वाइसमेलहरू हटाउन असफल',
      loading: 'लोड हुँदैछ...',
      none: 'कुनै भ्वाइसमेल छैन',
      status: 'स्थिति',
      received: 'प्राप्त समय',
      from: 'बाट',
      read: 'पढिएको',
      new: 'नयाँ',
      deleteAria: 'भ्वाइसमेल मेटाउनुहोस्',
      deleteSuccess: 'भ्वाइसमेल मेटियो',
      deleteFailed: 'भ्वाइसमेल मेटाउन असफल',
    },
  },
  wakeupScheduler: {
    scheduleSuccess: '{{count}} वेक-अप कल{{suffix}} तालिकाबद्ध गरियो',
    scheduleFailed: 'वेक-अप कलहरू तालिका गर्न असफल',
    selectDate: 'मिति छान्नुहोस्',
    selectTime: 'समय छान्नुहोस्',
    scheduleWakeupCalls: 'वेक-अप कल तालिका गर्नुहोस्',
    scheduling: 'तालिका हुँदैछ...',
    selectedRooms: '{{count}} कोठा{{suffix}} चयन गरियो',
    cancelSuccess: 'वेक-अप कल रद्द गरियो',
    cancelFailed: 'वेक-अप कल रद्द गर्न असफल',
    addToPendingAria: 'पेन्डिङ परिवर्तनमा थप्नुहोस्',
    pendingChanges: 'पेन्डिङ परिवर्तनहरू',
    noPendingChanges: 'अहिलेसम्म पेन्डिङ परिवर्तन छैन',
    applyChanges: 'परिवर्तन लागू गर्नुहोस्',
    reset: 'रिसेट',
    noMatchingRooms: 'मिल्ने कोठा भेटिएन',
    noRoomsAvailable: 'कुनै कोठा उपलब्ध छैन',
    roomNumber: 'कोठा नम्बर',
    roomName: 'कोठाको नाम',
    status: 'स्थिति',
    currentSchedule: 'हालको तालिका',
    selectAllRooms: 'सबै कोठाहरू चयन गर्नुहोस्',
    selectRoom: 'कोठा {{number}} चयन गर्नुहोस्',
    dayLabel: 'दिन',
    timeLabel: 'समय',
    filterTimesLabel: 'समय फिल्टर गर्नुहोस्',
    removePendingAria: 'कोठा {{room}} को बाँकी वेक-अप हटाउनुहोस्, {{time}}',
    cancelWakeupAria: 'कोठा {{room}} को {{time}} को वेक-अप रद्द गर्नुहोस्',
  },
  history: {
    noHistory: 'वेक-अप कल इतिहास छैन',
    noMatchingRecords: 'मिल्ने रेकर्ड फेला परेन',
    showing: '{{count}} रेकर्डमध्ये {{start}} देखि {{end}} देखाउँदै',
    filteredFromTotal: '(जम्मा {{total}} रेकर्डबाट फिल्टर गरिएको)',
    room: 'कोठा',
    roomName: 'कोठाको नाम',
    attempts: 'प्रयासहरू',
    wakeupDateTime: 'वेक-अप मिति र समय',
    activationDateTime: 'सक्रियता मिति र समय',
    wakeupStatus: 'वेक-अप स्थिति',
    originator: 'स्रोत',
    originPhone: 'फोन',
    originPortal: 'पोर्टल',
  },
  settings: {
    activation: 'सक्रियता',
    searchRoomsOrNames: 'कोठा वा नामबाट खोज्नुहोस्...',
    noMatchingExtensions: 'तपाईंको खोजसँग मिल्ने एक्सटेन्सन भेटिएन',
    noExtensionsForPbx: 'यस पीबीएक्सका लागि कुनै एक्सटेन्सन लाइन फेला परेन',
    active: 'सक्रिय',
    roomNumber: 'कोठा नम्बर',
    extensionName: 'एक्सटेन्सन नाम',
    currentStatus: 'हालको स्थिति',
    roomActiveAria: 'कोठा {{number}} सक्रिय',
    statusAtTime: '{{status}} ({{time}} - {{date}})',
    activated: 'सक्रिय गरियो',
    deactivated: 'निष्क्रिय गरियो',
    roomToggleStatus: 'कोठा {{roomNumber}} {{action}}',
    toggleHospitalityFailed: 'हस्पिटालिटी टगल गर्न असफल',
    resetRoomsToDirty: 'कोठालाई Dirty मा रिसेट गर्नुहोस्',
    everyDayAt: 'हरेक दिन @',
    manually: 'म्यानुअली',
    saveSchedule: 'सेभ गर्नुहोस्',
    scheduleSaveFailed: 'रिसेट तालिका अद्यावधिक गर्न असफल',
    manualResetEnabled: 'कोठाको स्थिति म्यानुअली रिसेट हुनेछ',
    dailyResetAt: 'कोठाको स्थिति दैनिक {{time}} मा रिसेट हुनेछ',
  },
} satisfies HotelsLocale
